/**
 * Форматирует ключ поля в читаемый вид: "Тип - Страна".
 * @param {string} key - Ключ поля (например, "cash_kurs_rub_thb").
 * @returns {string} Отформатированная строка (например, "Курс RUB/THB").
 */

export default (key) => {
  if (!key) return '';

  // Определяем тип поля
  let type = '';
  if (key.includes('kurs') || key.includes('curs')) {
    type = 'курс';
  } else if (key.includes('perc') || key.includes('percent')) {
    type = 'процент';
  } else if (key.includes('requisites') || key.includes('req') || key.includes('details')) {
    type = 'реквизиты';
  } else if (key.includes('min_') || key.includes('max_')) {
    if(key.includes('min_')) type = 'Минимум';
    if(key.includes('max_')) type = 'Максимум';
  } else {
    type = `параметр`;
  }

if(key.includes('limit')) {
    type += " лимит"
} 

  if (key.includes('sell')) {
    type += ' продажи';
  } else if (key.includes('buy')) {
    type += ' покупки';
  }

  // Определяем страны/валюты
  const countries = [];
  if (key.includes('rub')) countries.push('RUB');
  if (key.includes('thb')) countries.push('THB');
  if (key.includes('usdt')) countries.push('USDT');
  if (key.includes('kzt')) countries.push('KZT');
  if (key.includes('idr')) countries.push('IDR');
  if (key.includes('mmk')) countries.push('MMK');
  if (key.includes('try')) countries.push('TRY');
  if (key.includes('vnd')) countries.push('VND');
  if (key.includes('gel')) countries.push('GEL');
  if (key.includes('byn')) countries.push('BYN');
  if (key.includes('cny')) countries.push('CNY');

  // Форматируем вывод
  const countryStr = countries.length > 0 ? countries.join('/') : '';
  const result = `${type}${countryStr ? ` ${countryStr}` : ''} (${key})`

  return result.charAt(0).toUpperCase()+result.slice(1);
};